import jsBridge from "../../utils/jsBridge";
import { sources } from "./index";
function callHandler(type, params, callback) {
  jsBridge(function (bridge) {
    bridge.callHandler(type, params, function responseCallback(data) {
      var parseData = typeof data === "string" ? JSON.parse(data) : data;
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      callback && callback(parseData);
    });
  });
}
// 发送Ga事件
export function gaEvent(category, action, label) {
  if (sources.system === "web") {
    try {
      window.dataLayer.push({
        event: "gaEvent",
        eventCategory: category,
        eventAction: action,
        eventLabel: label
      });
    } catch (_a) {}
  } else {
    callHandler("appEventLogHandler", {
      types: ["ga_event"],
      ga_event: {
        category: category,
        action: action,
        label: label
      }
    });
  }
}
// 打开APP
export function openAppPage(params, callback) {
  callHandler("openAppPage", params, callback);
}
// 开启推送权限
export function appPushOpenSetting(callback) {
  callHandler("appPushOpenSetting", {}, callback);
}
// 分享调用（通用方法）
export function shareActivity(params, callback) {
  callHandler("shareActivity", params, callback);
}
// 设置导航是否显示（web页）
export function setNavigationBarHidden(params, callback) {
  callHandler("setNavigationBarHidden", params, callback);
}
// 获取当前APP及手机系统信息（通用）
export function fromApp(callback) {
  callHandler("FromApp", {}, callback);
}
// 关闭当前webview页面（通用）
export function finish(params, callback) {
  callHandler("finish", params, callback);
}
// 打开新的播放影音（影音播放）
export function openNewMovie(params, callback) {
  callHandler("openNewMovie", params, callback);
}
// 获取文章高度（导购文章）
export function infoScroll(params, callback) {
  callHandler("infoScroll", params, callback);
}
// web 調用告訴app 調用什麼 bridge
export function forceOcCallJsHandler(params, callback) {
  callHandler("ForceOcCallJsHandler", params, callback);
}
// 同步web登入狀態到App
export function logInFromWeb(params, callback) {
  callHandler("logInFromWeb", params, callback);
}
// web 通過web使用戶登出
export function logOutFromWeb(params, callback) {
  callHandler("logOutFromWeb", params, callback);
}
// web App事件統計
export function appEventLogHandler(params, callback) {
  callHandler("appEventLogHandler", params, callback);
}
// 下载来源连接
export function syncDownloadSourceLink(params, callback) {
  callHandler("syncDownloadSourceLink", params, callback);
}
// 下载来源连接
export function callTel(params, callback) {
  callHandler("callTel", params, callback);
}
/** 调整APP系统内部颜色 */
export function setAppContentColor(params, callback) {
  callHandler("setAppContentColor", params, callback);
}
// 调用g4方法
export function ga4Analysis(_ref) {
  var event = _ref.event,
    params = _ref.params,
    callback = _ref.callback;
  callHandler("ga4Analysis", {
    event: event,
    params: params
  }, callback);
}
// 触屏版传值给app
export function webCallBack(params, callback) {
  callHandler("webCallBack", params, callback);
}